import React, { useState } from 'react';
import './CustomerSupportComponent.css';
import { API_URLS } from './config';
import fetchWithAuth from './api';

const CustomerSupportComponent = ({ user, userPermissions, setToast }) => {
  const [topic, setTopic] = useState('');
  const [message, setMessage] = useState('');
  const MAX_MESSAGE_LENGTH = 1000;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        topic: topic,
        message: message,
      };

      const response = await fetchWithAuth(API_URLS.SAVEMESSAGE, user, userPermissions, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to send support request');
      }

      setToast({ message: 'Your support request has been submitted successfully!', type: 'success' });
      setTopic('');
      setMessage('');
    } catch (error) {
      console.error('Error submitting support request:', error);
      setToast({ message: 'Failed to submit support request. Please try again later.', type: 'error' });
    }
  };

  return (
    <div className="customer-support-component">
      <h2>How can we help you today?</h2>
      <form onSubmit={handleSubmit} className="support-form">
        <div className="form-group">
          <label htmlFor="topic">Topic:</label>
          <div className="input-container">
            <select
              id="topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              required
            >
              <option value="">--Please choose a topic--</option>
              <option value="account">Account Issues</option>
              <option value="billing">Billing Inquiry</option>
              <option value="technical">Technical Support</option>
              <option value="feedback">Feedback</option>
              <option value="other">Other</option>
            </select>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <div className="input-container">
            <textarea
              id="message"
              value={message}
              onChange={(e) => {
                if (e.target.value.length <= MAX_MESSAGE_LENGTH) {
                  setMessage(e.target.value);
                }
              }}
              maxLength={MAX_MESSAGE_LENGTH}
              rows="8"
              placeholder="Describe your issue or question (max 1000 characters)"
              required
            ></textarea>
            <div className="char-count">
              {message.length}/{MAX_MESSAGE_LENGTH} characters
            </div>
          </div>
        </div>
        <button type="submit" className="submit-button">Submit Request</button>
      </form>

      {/* Removed old support-sections as they are replaced by the form */}
    </div>
  );
};

export default CustomerSupportComponent;